import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-scroll";
import "./Navbar.css";

function Navbar() {
  const [navActive, setNavActive] = useState(false);
  const navRef = useRef(null);

  const toggleNav = () => setNavActive((v) => !v);
  const closeMenu = () => setNavActive(false);

  // Close menu when resizing above mobile breakpoint
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 980 && navActive) {
        setNavActive(false);
      }
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [navActive]);

  // Click outside and Escape key to close menu
  useEffect(() => {
    function handleKey(e) {
      if (e.key === "Escape") closeMenu();
    }
    function handleClickOutside(e) {
      if (navRef.current && !navRef.current.contains(e.target)) {
        closeMenu();
      }
    }

    document.addEventListener("keydown", handleKey);
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("keydown", handleKey);
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  // Prevent body scroll while mobile nav is open
  useEffect(() => {
    if (navActive) {
      document.body.style.overflow = "hidden";
      document.body.style.height = "100vh";
      document.body.style.width = "100%";
      document.body.style.position = "fixed";
    } else {
      document.body.style.overflow = "";
      document.body.style.height = "";
      document.body.style.width = "";
      document.body.style.position = "";
    }
    
    return () => {
      document.body.style.overflow = "";
      document.body.style.height = "";
      document.body.style.width = "";
      document.body.style.position = "";
    };
  }, [navActive]);

  return (
    <nav
      ref={navRef}
      className={`navbar ${navActive ? "active" : ""}`}
      aria-label="Main navigation"
      style={{ background: "#9ce4e3" }}
    >
      <div className="navbar-inner">
        <Link
          to="heroSection"
          spy={true}
          smooth={true}
          offset={-70}
          duration={500}
          className="logo-link"
          onClick={closeMenu}
          title="Go to top"
        >
          <img
            src="./img/logo2.svg"
            alt="Tahar Griach logo"
            className="logo-img"
            width={300}
            height="auto"
            loading="lazy"
          />
        </Link>

        {/* Desktop Contact Button - Hidden on Mobile */}


        <button
          type="button"
          className={`nav-hamburger ${navActive ? "active" : ""}`}
          aria-expanded={navActive}
          aria-controls="navbar-items"
          aria-label={navActive ? "Close menu" : "Open menu"}
          onClick={toggleNav}
        >
          <span className="line" />
          <span className="line" />
          <span className="line" />
        </button>

        <div id="navbar-items" className={`navbar-items ${navActive ? "active" : ""}`}>
          <div className="mobile-nav-content">
            <ul>
              <li>
                <Link
                  to="mySkills"
                  spy={true}
                  smooth={true}
                  offset={-70}
                  duration={500}
                  className="navbar-content"
                  activeClass="navbar--active-content"
                  onClick={closeMenu}
                >
                  Skills
                </Link>
              </li>

              <li>
                <Link
                  to="myexperience"
                  spy={true}
                  smooth={true}
                  offset={-70}
                  duration={500}
                  className="navbar-content"
                  activeClass="navbar--active-content"
                  onClick={closeMenu}
                >
                  Experiences
                </Link>
              </li>

              <li>
                <Link
                  to="MyPortfolio"
                  spy={true}
                  smooth={true}
                  offset={-70}
                  duration={500}
                  className="navbar-content"
                  activeClass="navbar--active-content"
                  onClick={closeMenu}
                >
                  Projects
                </Link>
              </li>

              <li>
                <Link
                  to="AboutMe"
                  spy={true}
                  smooth={true}
                  offset={-70}
                  duration={500}
                  className="navbar-content"
                  activeClass="navbar--active-content"
                  onClick={closeMenu}
                >
                  About Me
                </Link>
              </li>

              <li>
                <Link
                  to="testimonial"
                  spy={true}
                  smooth={true}
                  offset={-70}
                  duration={500}
                  className="navbar-content"
                  activeClass="navbar--active-content"
                  onClick={closeMenu}
                >
                  Certifications & Diplomas
                </Link>
              </li>
              <li>
                        <Link
          to="Contact"
          spy={true}
          smooth={true}
          offset={-70}
          duration={500}
          className="btn btn-outline-primary desktop-contact-cta"
          onClick={closeMenu}
        >
          Contact Me
        </Link>
              </li>
            </ul>
            
            {/* Mobile Contact Button - Only shown in mobile menu */}
            <Link
              to="Contact"
              spy={true}
              smooth={true}
              offset={-70}
              duration={500}
              className="btn btn-outline-primary mobile-contact-cta"
              onClick={closeMenu}
            >
              Contact Me
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;